import React from "react";
import { Container } from "reactstrap";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import "./Policies.css";

const RefundPolicyPage = () => (
  <>
    <Navbar />
    <main className="hn-policies-main">
      <Container className="py-4 py-md-5">
        <p className="hn-policies-updated">Last Updated: 2026-03-12</p>
        <h1 className="hn-policies-title">Refund Policy</h1>
        <div className="hn-policies-body">
          <p>
            A refund may be requested within 3 days of a new purchase if the service has not yet been deployed or activated.
          </p>
          <p>
            Refunds are only applicable to first-time purchases. Renewals, recurring subscriptions, and subsequent billing cycles are non-refundable.
          </p>
          <p>
            Once a dedicated instance or server environment has been deployed or configured, the purchase becomes non-refundable.
          </p>
          <p>
            If deployment requires user communication or credentials and the user fails to respond within 3 days, the order may be considered fulfilled and will not be eligible for refund.
          </p>
          <p>
            Refund requests must be submitted through official support channels.
          </p>
          <p>
            Hosting Noodle reserves the right to deny refund requests in cases of abuse, misuse of services, or violation of the Terms of Use.
          </p>
        </div>
      </Container>
    </main>
    <Footer />
  </>
);

export default RefundPolicyPage;
